import { http } from "../../../services/apiProduct/Http.interceptor";


const URL: string = '/vendedor/loja';

export const getUserStore = (id: string) => {
    return http.get<any[]>(`${URL}/${id}`);
}
